// const SERVER_URL = `http://localhost:3001`;
// const SERVER_URL = `https://wander-develop.herokuapp.com`;
const SERVER_URL = `https://api.wandertravelapp.com`;

const SOCKET_EVENTS = {
  LIVE_LOCATION: "LIVE_LOCATION",
};

export { SERVER_URL, SOCKET_EVENTS };
